module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "index-bannerAndSearch"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "index-search"
  }, [_c('div', {
    staticClass: "index-headerBox",
    on: {
      "click": _vm.toUser
    }
  }, [(_vm.userInfo.headimgurl) ? _c('img', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "src": _vm.userInfo.headimgurl,
      "alt": ""
    }
  }) : _c('img', {
    staticStyle: {
      "width": "20px",
      "border-radius": "0"
    },
    attrs: {
      "src": require("../assets/img/index/header-default.svg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPendingNum > 0),
      expression: "checkPendingNum > 0"
    }],
    staticClass: "index-checkPending",
    on: {
      "click": function($event) {
        return _vm.toNewPage('https://erp.newrank.cn/media/examine/project')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/header-toAde.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("待审核"), _c('span', {
    staticStyle: {
      "color": "#ff7800",
      "margin": "0 3px"
    }
  }, [_vm._v(_vm._s(_vm.checkPendingNum))]), _vm._v("个")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreNews.length),
      expression: "moreNews.length"
    }],
    staticClass: "index-news"
  }, [_c('img', {
    staticClass: "news-leftTitle",
    attrs: {
      "src": require("../assets/img/index/icon-notice.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('transition', {
    staticClass: "inner-container2",
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('p', {
    key: _vm.text.id,
    staticClass: "text2",
    staticStyle: {
      "max-height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.toNewPage(_vm.text.url)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.text.val && _vm.text.val.length > 22 ?
    _vm.text.val.substring(0, 22) + "..." :
    _vm.text.val) + "\n        ")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "news-more",
    on: {
      "click": _vm.showMoreNews
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#eee"
    }
  }, [_vm._v("|")]), _vm._v(" more")])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "index-linkList"
  }, _vm._l((_vm.linkListData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "linkList-item",
      on: {
        "click": function($event) {
          return _vm.toProduct(item)
        }
      }
    }, [(item.text == '品牌榜') ? _c('OpenWechat', {
      attrs: {
        "className": "wx-open-enter",
        "platform": "sq",
        "isWechatEnvProp": false,
        "path": "pages/Rank/RankList/index"
      }
    }) : _vm._e(), _vm._v(" "), (item.text == '账号榜') ? _c('OpenWechat', {
      attrs: {
        "className": "wx-open-enter",
        "platform": "sq",
        "isWechatEnvProp": false,
        "path": "pages/Rank/RankList/index?production=ranklist"
      }
    }) : _vm._e(), _vm._v(" "), (item.text == '账号榜') ? _c('div', {
      staticClass: "linkList-bangdan-new-day"
    }, [(_vm.bangdanNewStatus == 1) ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/bangdan-day.svg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.bangdanNewStatus == 2) ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/bangdan-week.svg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.bangdanNewStatus == 3) ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/bangdan-month.svg"),
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "linkList-item-icon",
      style: ({
        backgroundColor: item.color
      })
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.text))])], 1)
  }), 0), _vm._v(" "), (_vm.bannerData.length) ? _c('swipe', {
    staticClass: "index-advertisement",
    attrs: {
      "autoplayTime": _vm.autoplayTime,
      "pagination": _vm.pagination
    }
  }, _vm._l((_vm.bannerData), function(item, index) {
    return _c('swipe-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.img_url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.toNewPage(item.click_url)
        }
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "index-footer"
  }, [_vm._v("©2026 NEWRANK 沪公网安备31010402336499号")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notFollowBar),
      expression: "notFollowBar"
    }],
    staticClass: "not-follow-newrank"
  }, [_c('div', {
    staticClass: "not-follow-newrank-close",
    on: {
      "click": _vm.closeNotFollow
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "not-follow-newrank-text",
    on: {
      "click": _vm.notFollow
    }
  }, [_vm._v("\n      尚未关注「新榜服务」，可能会走丢\n    ")])]), _vm._v(" "), _c('Popup', {
    attrs: {
      "codeTitle": _vm.codeTitle,
      "codeImg": _vm.codeImg
    },
    model: {
      value: (_vm.codeShow),
      callback: function($$v) {
        _vm.codeShow = $$v
      },
      expression: "codeShow"
    }
  }), _vm._v(" "), _c('BottomRouter', {
    attrs: {
      "page": "index"
    }
  }), _vm._v(" "), (_vm.moreNewsShow && _vm.moreNews.length > 0) ? _c('MoreNews', {
    attrs: {
      "showData": _vm.moreNews
    },
    on: {
      "hideMoreNews": _vm.hideMoreNews
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-banner"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/img/index/banner.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a7d35e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 235
// module chunks = 45